const ABBR_PATTERN = /^(.+?)\(([^()]+)\)$/; // e.g. 'CSS (Cascading Style Sheets)'
export const abbreviationRole = {
    name: 'abbreviation',
    alias: ['abbr'],
    body: {
        type: String,
        required: true,
    },
    run(data) {
        var _a, _b, _c;
        const body = data.body;
        const match = ABBR_PATTERN.exec(body);
        const value = (_b = (_a = match === null || match === void 0 ? void 0 : match[1]) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : body.trim();
        const title = (_c = match === null || match === void 0 ? void 0 : match[2]) === null || _c === void 0 ? void 0 : _c.trim();
        return [{ type: 'abbreviation', title, children: [{ type: 'text', value }] }];
    },
};
